import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { PaycheckCommunicationOption } from './paycheck-communication-option.interface';

export class PaycheckCommunicationOptionService {
   async getPaycheckCommunicationOptions() {
      const response = await http.get<PaginatedResponse<PaycheckCommunicationOption>>(`/paycheck-communication-options`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getPaycheckCommunicationOption() {
      throw Error('Method not implemented');
   }

   async postPaycheckCommunicationOption() {
      throw Error('Method not implemented');
   }

   async putPaycheckCommunicationOption() {
      throw Error('Method not implemented');
   }

   async deletePaycheckCommunicationOption() {
      throw Error('Method not implemented');
   }
}
